import FormFieldMixins from "../form-field-mixin";
// eslint-disable-next-line no-unused-vars
import NumericUtils, { tempNumberFormatter } from "@/utils/numeric";

export default {
  name: "FormCurrency",
  mixins: [FormFieldMixins],
  props: {
    className: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "number"
    },
    renderSlot: {
      type: [Array, Boolean],
      default: false
    },
    fractionDigits: {
      type: [Function, Number],
      default: 0
    },
    currency: {
      type: String,
      default: ""
    },
    min: {
      type: Number,
      default: undefined
    },
    isAutoCatch: {
      type: Boolean,
      default: false
    },
    thousandSeparator: {
      type: String,
      default: ","
    },
    decimalSeparator: {
      type: String,
      default: "."
    }
  },
  watch: {
    value(newValue) {
      if (this.isAutoCatch) {
        this.localValue = newValue;
      }
    }
  },
  render(h) {
    if (!this.isDisplay) {
      return h();
    }
    return this.renderFormGroup(h);
  },
  computed: {
    renderFractionDigits() {
      return typeof this.fractionDigits === "function"
        ? this.fractionDigits()
        : this.fractionDigits;
    }
  },
  methods: {
    onInput($event, value = null) {
      $event.target.focus();
      let inputValue = value || $event.target.value;

      inputValue = inputValue.replace(/[^0-9.,-]*/g, "");
      const checkMin =
        this.min === null || this.min === undefined || this.min === "";

      if (checkMin || this.min < 0) {
        if (inputValue.includes("-")) {
          inputValue = inputValue.replace(/-/g, "");
          inputValue = `-${inputValue}`;
        }
      } else if (this.min === 0) {
        inputValue = inputValue.replace(/-/g, "");
      }

      let numericValue = parseFloat(inputValue.replace(/,/g, ""));

      if (!checkMin && !isNaN(this.min) && !isNaN(numericValue)) {
        if (numericValue < this.min) {
          numericValue = this.min;
          inputValue = numericValue.toString();
        }
      }
      this.initialValue = this.localValue;
      this.localValue = inputValue;
      this.emitLocalValue($event);
    },

    emitLocalValue($event) {
      this.isDirty = true;
      this.isChanged = this.initialValue !== this.localValue;
      this.$emit("input", $event, { name: this.name, value: this.localValue });
    },
    onKeydown($event) {
      const target = $event.target;
      const key = $event.key;
      const value = target.value || "";
      const decimalSeparators = [",", "."];
      const isDecimalKey = decimalSeparators.includes(key);
      const whitelistedKeyCodes = [37, 39];
      const allowedKeyCode = whitelistedKeyCodes.includes($event.keyCode);

      const decimalSepIndex = Math.max(value.indexOf(","), value.indexOf("."));
      const hasDecimals = decimalSepIndex !== -1;

      // Handle decimal separator input
      if (isDecimalKey) {
        if (
          hasDecimals ||
          key !== this.decimalSeparator ||
          !this.renderFractionDigits
        ) {
          $event.preventDefault();
        } else {
          // User is now entering decimals
          target.setAttribute("data-has-decimals", "true");
          target.setAttribute("data-decimal-number-count", "0");
        }
        return;
      }

      const isBackspaceOrDelete = $event.keyCode === 8 || $event.keyCode === 46;

      if (isBackspaceOrDelete) {
        if (!hasDecimals) {
          target.removeAttribute("data-has-decimals");
          target.removeAttribute("data-decimal-number-count");
        } else {
          // Recalculate decimal count from current value
          const decimalPart = value.split(/[,.]/)[1] || "";
          target.setAttribute("data-decimal-number-count", decimalPart.length);
        }
        return;
      }

      // Prevent overflow if typing in decimal part
      if (hasDecimals && !allowedKeyCode) {
        const decimalPart = value.split(/[,.]/)[1] || "";
        if (decimalPart.length >= this.renderFractionDigits) {
          $event.preventDefault();
        } else {
          // Update decimal count
          target.setAttribute(
            "data-decimal-number-count",
            decimalPart.length + 1
          );
        }
      }
    },
    // parseStringToFloat(value) {
    //   const float = parseFloat(String(value).replaceAll(this.thousandSeparator, '').replace(this.decimalSeparator, '.'))
    //   return float
    // },
    onKeyup($event) {
      if ($event.key === "k") {
        this.onInput($event, String($event.target.value * 1000));
        // this.emitLocalValue($event);
      }
      if ($event.key === "m") {
        this.onInput($event, String($event.target.value * 1000000));
        // const valueStr = String($event.target.value * 1000000)
        // this.localValue = formatCurrency(valueStr, this.renderFractionDigits, this.thousandSeparator, this.decimalSeparator)
        // this.emitLocalValue($event);
      }
    },
    onBlur($event) {
      if (this.initialValue !== this.localValue) {
        this.localValue = tempNumberFormatter(
          this.localValue,
          this.renderFractionDigits,
          this.thousandSeparator,
          this.decimalSeparator
        );
        this.initialValue = this.localValue;
      }
      const parentElement = $event.target.parentElement;
      parentElement.querySelector("span").style.display = "block";
      // this.isAutoCatch = false
      // this.emitLocalValue($event);
    },
    onFocus($event) {
      if (this.forceInvalidated) {
        this.forceInvalidated = false;
      }
      const parentElement = $event.target.parentElement;
      parentElement.querySelector("span").style.display = "none";
    },
    onMouseOver($event) {
      $event.target.value = NumericUtils.formatAmountAsNumber(
        this.value,
        this.renderFractionDigits
      );
    },
    onClickSpan(event) {
      event.target.style.display = "none";
      event.target.parentElement.querySelector("input").focus();
    },
    renderField(h) {
      const inputDirectives = [];
      if (this.validation) {
        inputDirectives.push({
          name: "validate",
          value: this.validation,
          expression: "validation"
        });
      }
      const value = this.localValue;
      const span = h(
        "span",
        {
          class: {
            "currency-text-display": true,
            "d-none": value === null || value === undefined
          },
          style: {
            pointerEvents: "none"
          },
          on: { click: this.onClickSpan }
        },
        tempNumberFormatter(
          this.value,
          this.renderFractionDigits,
          this.thousandSeparator,
          this.decimalSeparator
        )
      );
      const input = h("input", {
        domProps: { value },
        attrs: {
          id: this.name,
          type: "number",
          step: "1",
          name: this.name,
          placeholder: this.$t(this.placeholder),
          disabled:
            typeof this.disabled === "function"
              ? this.disabled()
              : this.disabled,
          readonly: this.readonly,
          "data-vv-as": this.label
          // 'data-has-decimals': 'false',
          // 'data-decimal-number-count': 0
        },
        class: {
          "form-control": !this.readonly,
          "is-invalid": this.forceInvalidated || this.isInvalid,
          "form-control-plaintext": this.readonly,
          "form-custom-fill": this.variant === "fill"
        },
        style: this.disabled
          ? {
              color: "transparent",
              caretColor: "transparent"
            }
          : {},
        on: {
          keydown: this.onKeydown,
          keyup: this.onKeyup,
          blur: this.onBlur,
          focus: this.onFocus,
          input: this.onInput,
          mouseover: this.onMouseOver
        },
        directives: inputDirectives
      });

      return h(
        "div",
        {
          class: {
            "input-currency-wrapper": true,
            "is-invalid": this.isInvalid
          }
        },
        [input, span]
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app-form/fields/form-currency.js